import Navbar from "@/components/navbar";
import B2BHeroSection from "@/components/b2b-hero-section";
import B2BBenefitsSection from "@/components/b2b-benefits-section";
import B2BBrandsSection from "@/components/b2b-brands-section";
// import B2BTestimonialsSection from "@/components/b2b-testimonials-section";
import Footer from "@/components/footer";
import LeadForm from "@/components/forms/LeadForm";
import { FORM_CONFIGS } from "@/config/forms";

export default function B2BRoadmapPage() {
  return (
    <>
      <Navbar />
      <main className="max-w-3xl mx-auto px-4 py-8 sm:py-16 flex flex-col gap-14">
        <B2BHeroSection />
        <B2BBenefitsSection />
        <B2BBrandsSection />
        <section id="join" className="scroll-mt-28">
          <LeadForm
            config={FORM_CONFIGS.b2b}
            submitLabel={<>GET IN TOUCH &rarr;</>}
          />
        </section>
        {/* <B2BTestimonialsSection /> */}
        <Footer />
      </main>
    </>
  );
}
